const contactNp = {
  breadcrumbs: { home: 'होम', contact: 'सम्पर्क' },
  hero: {
    title: 'हामीसँग सम्पर्क गर्नुहोस्',
    subtitle: 'तपाईंका कुनै पनि प्रश्न, सुझाव वा सहयोगका लागि हामी यहाँ छौं'
  },
  quick: {
    title: 'छिटो सहयोग पाउनुहोस्',
    actions: {
      liveChat: { title: 'लाईभ च्याट', desc: 'झटपट सहयोग पाउनुहोस्', cta: 'च्याट सुरु गर्नुहोस्' },
      helpCenter: { title: 'सहायता केन्द्र', desc: 'सामान्य प्रश्नहरूको उत्तर', cta: 'सहायता हेर्नुहोस्' },
      business: { title: 'व्यावसायिक सोधपुछ', desc: 'साझेदारी र सहकार्य', cta: 'सम्पर्क गर्नुहोस्' }
    }
  },
  info: {
    title: 'सम्पर्क जानकारी',
    service: { title: 'ग्राहक सेवा', desc: 'बिहान ९ देखि राति ९ सम्म' },
    email: { title: 'इमेल', desc: '२४ घण्टाभित्र जवाफ दिन्छौं' },
    address: {
      title: 'ठेगाना',
      desc: 'शनिबारदेखि बिहीबार, ९ बजे - ६ बजे',
      primary: 'घर #12, कलेज रोड,',
      secondary: 'दुखा फकीर मोड, गुरुदासपुर, नाटोर - 6440'
    }
  },
  form: {
    title: 'सन्देश पठाउनुहोस्',
    desc: 'तपाईंको विवरणसहित फारम भर्नुहोस्। हामी २४ घण्टाभित्र सम्पर्क गर्नेछौं।',
    name: 'नाम',
    email: 'इमेल',
    phone: 'फोन',
    subject: 'विषय',
    message: 'सन्देश',
    messagePh: 'तपाईंको प्रश्न वा टिप्पणी विस्तृत रूपमा लेख्नुहोस्...',
    submit: 'पठाउनुहोस्',
    success: 'तपाईंको सन्देश सफलतापूर्वक पठाइएको छ। चाँडै सम्पर्क गर्नेछौं।'
  },
  hours: {
    title: 'अफिस समय',
    weekdays: 'शनिबार - बिहीबार',
    friday: 'शुक्रबार',
    note: 'शुक्रबार सार्वजनिक बिदाका कारण कार्यालय सेवा सीमित हुन्छ'
  },
  social: { title: 'सामाजिक सञ्जाल' },
  faq: {
    title: 'प्रायः सोधिने प्रश्नहरू',
    subtitle: 'हाम्रो सहायता खण्डमा तपाईंलाई जवाफ भेटिन सक्छ',
    cta: 'सहायता केन्द्रमा जानुहोस्'
  }
};

export default contactNp;


